import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Provider } from './../../common/ComponentIdContext';
import MessageHub from '../../../core/signalr/SignalrMessageHub';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import Search from './Search';
import ScrollComponent from './../../common/ScrollComponent';
import TopInfoContent from './TopInfoContent';
import Table from './Table';
import { Export } from '../../common/export';
import GroupButton from '../time-and-sales/top-content/group-button';
import {
  changeCode,
  fetchInfoTicker,
  subscribeRealtimeTick,
  fetchDataQuoteMovement,
} from './reducer';
import PreRender from './../../common/PreRender';
import withMarketPreOpen from '../../common/market-pre-open/withMarketPreOpen';
import { compose } from 'redux';
import { removeDragCode, formatComGroupCode } from '../../helpers/Common';
import Footer from '../../common/table/Footer';

class QuoteMovement extends Component {
  componentDidMount() {
    const {
      fetchInfoTicker,
      id,
      dragCode,
      changeCode,
      glContainer,
      fetchDataQuoteMovement,
    } = this.props;
    MessageHub.subscribe(
      ChanelConfig.TickChanel,
      this.dispatchDataRealtimeTick,
    );
    const code = this.getDefaultCode();
    fetchInfoTicker(id, code);
    const params = dragCode ? { Code: dragCode.organCode } : {};
    fetchDataQuoteMovement(params, id);
    if (dragCode) {
      changeCode(
        {
          code: dragCode.organCode,
          displayCode: dragCode.ticker,
          codeName: dragCode.organShortName,
          exchange: formatComGroupCode(dragCode.comGroupCode),
        },
        id,
        false,
      );
    }
    removeDragCode(glContainer);
  }

  dispatchDataRealtimeTick = data => {
    const { subscribeRealtimeTick, id } = this.props;
    subscribeRealtimeTick(data, id);
  };

  componentWillUnmount() {
    MessageHub.unsubscribe(
      ChanelConfig.TickChanel,
      this.dispatchDataRealtimeTick,
    );
  }

  getDefaultCode = () => {
    const { dragCode } = this.props;

    return dragCode ? dragCode.organCode : 'AAA';
  };

  render() {
    const { id } = this.props;

    return (
      <PreRender {...this.props}>
        <Provider value={id}>
          <ScrollComponent appendClassName="ts-wrapper">
            <div className="px-20 pt-8 h-100 d-flex flex-column">
              <div className="ts-top-navigation">
                <div className="ts-top-navigation--left">
                  <div style={{ minWidth: 200, marginRight: 20 }}>
                    <Search />
                  </div>
                  <TopInfoContent />
                  <GroupButton />
                </div>
                <div className="ts-top-navigation--right">
                  <Export
                    exportId={`time-and-sale-export-${id}`}
                    exportName={`time-and-sale-${id}.png`}
                  />
                </div>
              </div>
              <div className="pt-10 top-mover-content d-flex flex-fill">
                <Table />
              </div>
              <Footer />
            </div>
          </ScrollComponent>
        </Provider>
      </PreRender>
    );
  }
}

const mapDispatchToProps = {
  fetchDataQuoteMovement,
  changeCode,
  fetchInfoTicker,
  subscribeRealtimeTick,
};

export default compose(
  connect(
    null,
    mapDispatchToProps,
  ),
  withMarketPreOpen(),
)(QuoteMovement);
